module.exports = __webpack_public_path__ + "img/1502902571.aceff8ba.jpg";